import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-[#0f0f0f] flex items-center justify-center px-4"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="w-12 h-12 rounded-full bg-[#1a1a1a] border border-[#2a2a2a] flex items-center justify-center mb-4">
            <Lock size={20} className="text-[#D8C08F]" />
          </div>
          <h1 className="text-white text-xl font-sans font-semibold tracking-tight">
            Admin Panel
          </h1>
          <p className="text-[#666] text-sm mt-1 font-sans">
            Sign in to manage your store
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div
              className="bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-3 text-red-400 text-sm font-sans"
              data-testid="login-error"
            >
              {error}
            </div>
          )}

          <div>
            <label className="block text-[#888] text-xs font-sans mb-1.5 uppercase tracking-wider">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg px-4 py-3 text-white text-sm font-sans focus:outline-none focus:border-[#D8C08F] transition-colors"
              placeholder="admin@shopthing.com"
              required
              data-testid="login-email-input"
            />
          </div>

          <div>
            <label className="block text-[#888] text-xs font-sans mb-1.5 uppercase tracking-wider">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg px-4 py-3 text-white text-sm font-sans focus:outline-none focus:border-[#D8C08F] transition-colors"
              placeholder="Enter password"
              required
              data-testid="login-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-[#D8C08F] text-black font-semibold py-3 rounded-lg text-sm font-sans tracking-wide hover:bg-[#c5ad7d] transition-colors disabled:opacity-50"
            data-testid="login-submit-button"
          >
            {submitting ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
